import { useState, useMemo } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import "./tablaDetalleAgrupada.css"


const transformarListaADatosTreeTable = ( lista=[] ) => {

  const proveedoresMap = {};

  lista.forEach((reg, index) => {
    const proveedor = reg.Proveedor;
    const remito = reg.sRemito;
    const nombre = reg.MercaderiaDescripcion;

    if (!proveedoresMap[proveedor]) {
      proveedoresMap[proveedor] = {
        key: `prov-${proveedor}`,
        data: { name: proveedor, tipo: "Proveedor", proveedor },
        children: {},
      };
    }

    const remitos = proveedoresMap[proveedor].children;

    if (!remitos[remito]) {
      remitos[remito] = {
        key: `prov-${proveedor}-rem-${remito}`,
        data: {
          name: `Remito ${remito}`,
          tipo: "Remito",
          proveedor,
          remito,
        },
        children: [],
      };
    }

    remitos[remito].children.push({
      key: `prov-${proveedor}-rem-${remito}-reg-${index}`,
      data: {
        ...reg,
        name: nombre,
        tipo: "Registro",
        proveedor,
        remito,
      },
    });
  });

  return Object.values(proveedoresMap).map((prov) => ({
    ...prov,
    children: Object.values(prov.children),
  }));
};

export const obtenerCantidadDetalle = (node) => {
  const data = node?.data;
  if (!data || data.tipo !== "Registro") return null;

  return data.nCantidad ?? data.nPesoOriginal ?? data.nPeso ?? null;
};

export default function TablaDetalleAgrupada({
  lista = [],
  mapToPayload = (r) => r.sCodbar,
  onDelete,
  onPrint,
  showActions = true
}) {
  const nodes = useMemo(
    () => transformarListaADatosTreeTable(lista),
    [lista]
  );

  const [selectedNodeKeys, setSelectedNodeKeys] = useState({});



  const registrosDelNodo = (tipo, data) => {
    if (tipo === "Proveedor") {
      return (lista || []).filter((r) => r.Proveedor === data.proveedor);
    }
    if (tipo === "Remito") {
      return (lista || []).filter((r) => r.Proveedor === data.proveedor && r.sRemito === data.remito);
    }
    return [data]

  }

  const handleDelete = (node) => {
    const regs = registrosDelNodo(node.data.tipo, node.data);
    const payload = regs.map(mapToPayload).filter(Boolean);
    if (!payload.length) return;
    onDelete?.(node.data.tipo, {
      proveedor: node.data.proveedor,
      remito: node.data.remito,
      registros: regs,
      payload,
    });
  };


  const accionesTemplate = (node) => {
    if (!showActions) return null;

    return (
      <div className="accioness">
        <button
          type="button"
          className="p-button p-button-text"
          onClick={() => handleDelete(node)}
          title="Eliminar"
        >
          <i className="pi pi-trash" />
        </button>
        <button
          type="button"
          className=""
          title="Imprimir"
          onClick={() => onPrint?.(node.data, { records: registrosDelNodo(node.data.tipo, node.data) })}
        >
          <i className="pi pi-print" />
        </button>
      </div>
    );
  };

  return (
    <div className="detalle-registros">
      <TreeTable
        value={nodes}
        selectionKeys={selectedNodeKeys}
        onSelectionChange={(e) => setSelectedNodeKeys(e.value)}
        emptyMessage="No hay registros"
      >
        <Column field="name" header="Nombre" expander />
        <Column field="sCodbar" header="Código QR" />
        <Column body={obtenerCantidadDetalle} header="Cantidad" />
        <Column field="UnidadDescripcion" header="Unidad" />
        <Column field="nConsumido" header="Consumido" />
        <Column field="sLote" header="Lote" />
        <Column body={accionesTemplate} header="" />
      </TreeTable>
    </div>
  );
}
